module.exports = __webpack_public_path__ + "src/assets/img/photo-fruit-1.104e6928.png";